import React, { useState, useEffect } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useForm, Controller } from 'react-hook-form'
import LoaderDots from '../../components/loaderDots'
import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date'
import axios from 'axios'
import { event } from '../../components/analytics'
import Card from './Card'
import TitleSection from './TitleSection'

import CountryField from '../CountryField'

import ArrayToOptions from '../ArrayToOptions'

export default function Form(props) {
  const {
    handleSubmitEvent,
    updateInputState,
    onBirthDateChange,
    formInputs,
    ageOnYear,
    i18n,
  } = props

  const [loadingBeltOptions, setLoadingBeltOptions] = useState(false)
  const [beltsOptions, setBeltOptions] = useState([])
  const { membershipType, country, birth } = formInputs

  const { handleSubmit, errors, control } = useForm()

  useEffect(() => {
    fetchBelts()
  }, [ageOnYear])

  const translateBelts = (belts) => {
    return belts.map((belt) => {
      return { label: i18n.t(`belts.${belt.colorName}`), value: belt.colorName }
    })
  }

  const fetchBelts = () => {
    if (ageOnYear) {
      setLoadingBeltOptions(true)

      return axios
        .get('/api/v1/belts/list.json', {
          params: { age: ageOnYear },
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        .then((response) => {
          setBeltOptions(
            ArrayToOptions(
              translateBelts(response.data.belts),
              'value',
              'label'
            )
          )
          setLoadingBeltOptions(false)
        })
        .catch((error) => {
          setLoadingBeltOptions(false)
          console.log(error)
        })
    } else {
      return []
    }
  }

  const minorAgeMessages = {
    experiencedAthlete: i18n.t(
      'membership.form.birthDate.minorMensages.experiencedAthlete'
    ),
    juvenile: i18n.t('membership.form.birthDate.minorMensages.juvenile'),
  }

  const ageMessages = () => {
    if (props.formInputs.belt.value != 'white') return null

    if (props.ageOnYear >= 16) {
      return (
        <React.Fragment>
          <p className="mt-2">
            <small className="membership-white-belt-message font-italic">
              {ReactHtmlParser(minorAgeMessages['experiencedAthlete'])}
            </small>
          </p>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <p className="mt-2">
            <small className="membership-white-belt-message font-italic">
              {ReactHtmlParser(minorAgeMessages['juvenile'])}
            </small>
          </p>
        </React.Fragment>
      )
    }
  }
  const renewMembershipUrl = () => {
    const baseUrl = `${App.INFOSITE_APP_URL}/${
      i18n.language === 'en' ? 'en-US' : 'pt-BR'
    }`

    return `${baseUrl}/athletes/memberships/update`
  }

  const onBeltClick = (e, belt) => {
    e.preventDefault()

    updateInputState({
      target: {
        name: 'belt',
        value: {
          label: belt.label,
          value: belt.value,
        },
      },
    })
  }

  return (
    <form onSubmit={handleSubmit(handleSubmitEvent)} noValidate>
      <TitleSection
        title={i18n.t('membership.form.application')}
        subtitle={!membershipType ? i18n.t('membership.form.subtitle') : ''}
        subtitleInfo={i18n.t('membership.form.subtitleInfo')}
      />

      <section className="row">
        {(!membershipType || membershipType === 'adult') && (
          <div
            className={`col-sm-12 ${
              membershipType ? 'col-md-12' : 'col-md-4'
            } mt-4 mt-md-0`}
          >
            <Card
              type="dark"
              title={i18n.t('membership.new.title')}
              text={i18n.t('membership.new.subtitle')}
              list={[
                i18n.t('membership.benefits.validity'),
                i18n.t('membership.benefits.events'),
                i18n.t('membership.benefits.history'),
              ]}
              price={i18n.t('membership.new.price')}
              pricePeriod={i18n.t('membership.new.pricePeriod')}
              btnText={i18n.t('membership.new.action')}
              i18n={i18n}
              attentionText={i18n.t('membership.new.attentionText')}
              isSignUp
              isCollapsible={!!membershipType}
              onActionBtnClick={() => {
                updateInputState({
                  target: {
                    name: 'membershipType',
                    value: 'adult',
                  },
                })
              }}
            />
          </div>
        )}

        {(!membershipType || membershipType === 'minor') && (
          <div
            className={`col-sm-12 ${
              membershipType ? 'col-md-12' : 'col-md-4'
            } mt-4 mt-md-0`}
          >
            <Card
              type="dark"
              title={i18n.t('membership.minor.title')}
              text={i18n.t('membership.minor.subtitle')}
              list={[
                i18n.t('membership.benefits.validity'),
                i18n.t('membership.benefits.events'),
                i18n.t('membership.benefits.history'),
              ]}
              price={i18n.t('membership.minor.price')}
              pricePeriod={i18n.t('membership.minor.pricePeriod')}
              btnText={i18n.t('membership.minor.action')}
              i18n={i18n}
              attentionText={i18n.t('membership.minor.attentionText')}
              isSignUp
              isCollapsible={!!membershipType}
              onActionBtnClick={() => {
                updateInputState({
                  target: {
                    name: 'membershipType',
                    value: 'minor',
                  },
                })
              }}
            />
          </div>
        )}

        {!membershipType && (
          <div className="col-sm-12 col-md-4 mt-4 mt-md-0">
            <Card
              type="primary"
              title={i18n.t('membership.renewal.title')}
              text={i18n.t('membership.renewal.subtitle')}
              list={[
                i18n.t('membership.benefits.validity'),
                i18n.t('membership.benefits.events'),
                i18n.t('membership.benefits.history'),
              ]}
              price={i18n.t('membership.renewal.price')}
              pricePeriod={i18n.t('membership.renewal.pricePeriod')}
              btnText={i18n.t('membership.renewal.action')}
              btnUrl={renewMembershipUrl()}
              attentionText={i18n.t('membership.renewal.attentionText')}
              i18n={i18n}
            />
          </div>
        )}

        {['adult', 'minor'].includes(membershipType) && (
          <div className="col-sm-12 second-col mt-4">
            <div className="form-group">
              <label className="membership-form-label">
                {i18n.t('membership.form.birthDate.label')}
              </label>
              <div className="birth-date-container">
                <Controller
                  onChange={(month) => {
                    onBirthDateChange({
                      target: { name: 'month', value: month },
                    })

                    return month
                  }}
                  name="month"
                  control={control}
                  value={birth.month}
                  rules={{ required: true }}
                  as={
                    <MonthPicker
                      defaultValue={i18n.t('membership.form.birthDate.month')}
                      id="month"
                      classes={`form-control month ${
                        errors.month && 'is-invalid'
                      }`}
                      localizedMonths={
                        i18n.language === 'pt-BR'
                          ? i18n.t('membership.form.translatedMonths', {
                              returnObjects: true,
                            })
                          : {}
                      }
                    />
                  }
                />

                <Controller
                  onChange={(value) => {
                    onBirthDateChange({
                      target: { name: 'day', value: value },
                    })
                    return value
                  }}
                  name="day"
                  control={control}
                  value={birth.day}
                  rules={{ required: true }}
                  as={
                    <DayPicker
                      defaultValue={i18n.t('membership.form.birthDate.day')}
                      month={birth.month}
                      year={birth.year}
                      id="day"
                      name="day"
                      classes={`form-control day ${errors.day && 'is-invalid'}`}
                    />
                  }
                />
                <Controller
                  onChange={(value) => {
                    onBirthDateChange({
                      target: { name: 'year', value: value },
                    })
                    return value
                  }}
                  name="year"
                  control={control}
                  value={birth.year}
                  rules={{ required: true }}
                  as={
                    <YearPicker
                      defaultValue={i18n.t('membership.form.birthDate.year')}
                      reverse={true}
                      start={
                        membershipType === 'minor'
                          ? new Date().getFullYear() - 17
                          : 1900
                      }
                      end={
                        membershipType === 'adult'
                          ? new Date().getFullYear() - 18
                          : new Date().getFullYear() - 4
                      }
                      id="year"
                      name="year"
                      classes={`form-control year ${
                        errors.year && 'is-invalid'
                      }`}
                    />
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label className="membership-form-label">
                {i18n.t('membership.form.belt')}
              </label>
              <div className="d-flex flex-wrap">
                {loadingBeltOptions ? (
                  <LoaderDots />
                ) : beltsOptions.length ? (
                  beltsOptions.map((belt, i) => (
                    <button
                      key={i}
                      className="membership-belt-btn btn btn-sm btn-primary"
                      onClick={(e) => {
                        onBeltClick(e, belt)
                      }}
                    >
                      {i18n.t(`belts.${belt.value}`)}
                    </button>
                  ))
                ) : (
                  <small className="membership-belt-warning">
                    {i18n.t('membership.form.birthDateWarning')}
                  </small>
                )}
              </div>

              <div className="age-info my-3">{ageMessages()}</div>
            </div>

            <CountryField
              updateInputState={updateInputState}
              country={country}
              errors={errors}
              control={control}
              label={i18n.t('membership.form.country')}
              fieldName="country"
              placeholder={i18n.t('membership.form.selectCountry')}
              fieldId="country-field"
            />

            <div className="d-flex">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary mr-2"
                onClick={() =>
                  updateInputState({
                    target: {
                      name: 'membershipType',
                      value: null,
                    },
                  })
                }
              >
                {i18n.t('membership.form.back')}
              </button>

              <button
                type="submit"
                className="btn btn-sm btn-primary"
                onClick={() => event('Membership', 'Membership docs displayed')}
              >
                {i18n.t('membership.form.go')}
              </button>
            </div>
          </div>
        )}
      </section>
    </form>
  )
}
